import { gql } from 'apollo-boost';

const createApplicantAndToken = gql`
  mutation createApplicantAndToken($request : CreateApplicantAndTokenRequestType!) {
    createApplicantAndToken(request:$request) {
      token
      checkData
      selfieFormWebUrl
      provider
    }
  }
`;

export default createApplicantAndToken;